import React, { Component, SyntheticEvent } from "react";
import "./Public.css";
import axios from "axios";
import { Redirect } from "react-router-dom";

type State = {
    redirect: boolean;
    loading: boolean;
    error?: string;
};

class Login extends Component<any, State> {
    email = "";
    password = "";

    state: State = { redirect: false, loading: false, error: undefined };

    submit = async (e: SyntheticEvent) => {
        e.preventDefault();
        this.setState({ loading: true, error: undefined });

        try {
            const res = await axios.post(
                "login/",
                { email: this.email, password: this.password },
                { withCredentials: true }
            );

            // At this point, the interceptor guaranteed it's a real success
            const token = (res as any)?.data?.data?.jwt || (res as any)?.data?.token || null;
            if (token) localStorage.setItem("token", token);
            localStorage.setItem("auth", "true");

            this.setState({ redirect: true, loading: false });
        } catch (err: any) {
            const serverMsg =
                err?.userMessage ||
                err?.response?.data?.message ||
                "Invalid email or password.";
            this.setState({ loading: false, error: serverMsg });
        }
    };

    render() {
        if (this.state.redirect) {
            const from =
                this.props?.location?.state?.from?.pathname || "/dashboard";
            return <Redirect to={from} />;
        }

        return (
            <div className="auth-wrap">
                <div className="brand">
                    <img src="images/easteco-logo.png" alt="EASTECO logo" className="brand__logo" />
                    <h1 className="brand__title">
                        East Africa - Science and Technology Indicators Dashboard
                    </h1>
                </div>

                <form className="form-signin" onSubmit={this.submit}>
                    <h2 className="form-title">Please sign in</h2>

                    {this.state.error && (
                        <div className="alert alert-danger" role="alert">
                            {this.state.error}
                        </div>
                    )}

                    <label htmlFor="inputEmail" className="sr-only">Email address</label>
                    <input
                        type="email"
                        id="inputEmail"
                        className="form-control"
                        placeholder="Email address"
                        required
                        onChange={(e) => (this.email = e.target.value)}
                    />

                    <label htmlFor="inputPassword" className="sr-only">Password</label>
                    <input
                        type="password"
                        id="inputPassword"
                        className="form-control"
                        placeholder="Password"
                        required
                        onChange={(e) => (this.password = e.target.value)}
                    />

                    <button className="btn btn-lg btn-primary btn-block" type="submit" disabled={this.state.loading}>
                        {this.state.loading ? "Signing in..." : "Sign in"}
                    </button>
                </form>
            </div>
        );
    }
}

export default Login;
